import {DurableFunctionInstance, DurableFunctionInstanceHelpers} from "../../../models/DurableFunctionInstance";
import {BulkComparisonItemOutput} from "./BulkComparisonItemOutput";


export interface BulkItemInstance extends DurableFunctionInstance
{
    ParsedOutput: BulkComparisonItemOutput
}

export function parseBulkItemInstance(instance: DurableFunctionInstance): BulkItemInstance
{
    const withParsed = instance as BulkItemInstance;
    withParsed.ParsedOutput = DurableFunctionInstanceHelpers.ParseOutput(instance);
    return withParsed
}